<template>
  <v-dialog persistent v-model="dialog" max-width="400">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small dark color="red" @click="declined()">Annulla</v-btn>
        <v-btn small dark color="green" @click="confirmed()">Conferma</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: [ 'item' ],

  data: ()=> ({
    dialog: false,
    title: '',
    message: '',
  }),

  methods: {
    confirm(title, message){
      this.title = title;
      this.message = message;
      this.dialog = true;
    },

    confirmed(){
      this.dialog = false;
      this.$emit('confirmed', true, this.item);
    },

    declined(){
      this.dialog = false;
      this.$emit('confirmed', false, this.item);
    }
  }
}
</script>